import { render, staticRenderFns } from "./AdminLogs.vue?vue&type=template&id=df79acfe&scoped=true"
import script from "./AdminLogs.vue?vue&type=script&lang=js"
export * from "./AdminLogs.vue?vue&type=script&lang=js"
import style0 from "./AdminLogs.vue?vue&type=style&index=0&id=df79acfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df79acfe",
  null
  
)

export default component.exports